export default "__VITE_ASSET__e444843b__"